import { getCookie, setCookie } from '../../DAL/storage-provider';

const GDRP_COOKIE_NAME = 'gdpr';

export interface IGdpr {
    IsCountryGDPR: string, // "y", "n"
    IsMarketing: boolean,
    IsPerformance: boolean,
    ItemModifiedWhen: string, // "2022-07-31T12:57:15.7440792"
}

export const getGdprCookie = () : null | IGdpr => {
    const cookie = getCookie(GDRP_COOKIE_NAME);
    if(!cookie) return null;

    let parsed: IGdpr | null = null;

    try{
        parsed = JSON.parse(cookie) as IGdpr;
    }
    catch(ex){}

    return parsed;
};

/**
 * waves-min
 * gdpr-cookie-policy-min
 */
export const setGDPRCookie = (data: IGdpr) => {

    const expiration = -1;
    const secure = false;
    const sameSite = undefined;
    const preventStringify = false;
    const domain = '.waves.com';

    setCookie('gdpr', data, expiration, secure, sameSite, preventStringify, domain);
};